export default "__VITE_ASSET__c7Tx7KSs__"